var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('pages-core-view'),_c('pages-core-footer'),_c('SnackBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }